import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

export function mapBoardMemberFromApi(d) {
  const companyId = d.companyId ?? d.branchId;
  return {
    id: d.id,
    name: d.name ?? '',
    position: d.position ?? '',
    branchId: companyId,
    branch: d.companyName ?? d.branchName ?? '',
    boardId: d.boardId ? String(d.boardId) : '',
    boardName: d.boardName ?? '',
    phone: d.phone ?? '',
    email: d.email ?? '',
    userName: d.userName ?? '',
    hasAccount: !!d.hasAccount,
    status: d.isActive ? 'active' : 'inactive',
    nationality: d.nationality ?? '',
    nationalId: d.nationalId ?? '',
    birthDate: d.birthDate ? String(d.birthDate).slice(0, 10) : '',
    membershipType: d.membershipType ?? '',
    membershipStartDate: d.membershipStartDate ? String(d.membershipStartDate).slice(0, 10) : '',
    membershipEndDate: d.membershipEndDate ? String(d.membershipEndDate).slice(0, 10) : '',
    partnerKind: d.partnerKind ?? '',
    photoData: d.photoData ?? '',
  };
}

export function mapBoardFormToPayload(form) {
  return {
    name: form.name?.trim() ?? '',
    position: form.position?.trim() ?? '',
    companyId: Number(form.branchId),
    boardId: form.boardId ? Number(form.boardId) : null,
    newBoardName: form.newBoardName?.trim() || null,
    userName: form.userName?.trim() ?? '',
    password: form.password?.trim() || null,
    phone: form.phone?.trim() || null,
    email: form.email?.trim() || null,
    isActive: form.status === 'active',
    nationality: form.nationality?.trim() || null,
    nationalId: form.nationalId?.trim() || null,
    birthDate: form.birthDate || null,
    membershipType: form.membershipType?.trim() || null,
    membershipStartDate: form.membershipStartDate || null,
    membershipEndDate: form.membershipEndDate || null,
    partnerKind: form.partnerKind || null,
    photoData: form.photoData || null,
  };
}

export function mapDirectorFormToPayload(form) {
  return {
    name: form.name?.trim() ?? '',
    position: form.membershipType?.trim() || 'عضو مجلس إدارة',
    companyId: Number(form.branchId),
    boardId: null,
    newBoardName: null,
    userName: form.userName?.trim() || null,
    password: form.password?.trim() || null,
    phone: form.phone?.trim() || null,
    email: form.email?.trim() || null,
    isActive: form.status !== 'inactive',
    nationality: form.nationality?.trim() || null,
    nationalId: form.nationalId?.trim() || null,
    birthDate: form.birthDate || null,
    membershipType: form.membershipType?.trim() || null,
    membershipStartDate: form.membershipStartDate || null,
    membershipEndDate: form.membershipEndDate || null,
    partnerKind: form.partnerKind || null,
    photoData: form.photoData || null,
  };
}

export async function fetchBoardMembers() {
  const res = await fetch(`${API_BASE}/api/boardmembers`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل أعضاء المجلس'));
  const list = Array.isArray(data) ? data : [];
  return list.map(mapBoardMemberFromApi);
}

export async function fetchBoardMemberById(id) {
  const res = await fetch(`${API_BASE}/api/boardmembers/${id}/detail`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل بيانات العضو'));
  return mapBoardMemberFromApi(data);
}

export async function createBoardMember(payload) {
  const res = await fetch(`${API_BASE}/api/boardmembers`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة العضو'));
  return mapBoardMemberFromApi(data);
}

export async function updateBoardMember(id, payload) {
  const res = await fetch(`${API_BASE}/api/boardmembers/${id}/edit`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر حفظ التعديلات'));
  return mapBoardMemberFromApi(data);
}

export async function createBoardMemberFromUser(payload) {
  const res = await fetch(`${API_BASE}/api/boardmembers/from-user`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة العضو من المستخدمين'));
  return mapBoardMemberFromApi(data);
}

export async function deleteBoardMember(id) {
  const res = await fetch(`${API_BASE}/api/boardmembers/${id}`, {
    method: 'DELETE',
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  if (res.status === 204) return;
  const data = await res.json().catch(() => ({}));
  throw new Error(messageFromErrorBody(data, 'تعذر حذف العضو'));
}
